import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function BillingError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot get billing details'}
    </Alert>
  );
}

export { BillingError };